import { Injectable } from "@angular/core";
import { Observable, forkJoin } from "rxjs";

import { LdsClientService } from "../../providers/lds-client/lds-client.service";
import { Signaltag } from "../../models/trend-live-models/OPTag";
import { map } from "rxjs/operators";
import * as _ from "lodash";
import { Equipment } from "../../models/equipment";
import * as moment from "moment";
import { TemplateProvider } from "../../providers/template/template";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";

interface TrendExplorerConfig {
  tags: Signaltag[];
  timezone: string;
  dataSource: string;
}

@Injectable()
export class TrendExplorerService {
  constructor(
    private starms: StarmsClientProvider,
    private lds: LdsClientService,
    private templateService: TemplateProvider
  ) {}

  createFlagsData(
    eventsArray
  ): Array<{ x: number; color: string; symbol: string; description: string }> {
    const objectToAdd = [];

    for (const i in eventsArray) {
      if (eventsArray.hasOwnProperty(i)) {
        let symbol, symColor;

        if (
          eventsArray[i].eventDescription.toLowerCase().indexOf("attempt") ===
            -1 &&
          eventsArray[i].eventDescription
            .toLowerCase()
            .indexOf("initial state") === -1 &&
          eventsArray[i].eventDescription.toLowerCase().indexOf("shutdown") ===
            -1
        ) {
          if (
            eventsArray[i].eventDescription.toLowerCase().indexOf("stop") !== -1
          ) {
            symbol = "square";
            symColor = "#92D050";
          } else if (
            eventsArray[i].eventDescription.toLowerCase().indexOf("trip") !== -1
          ) {
            symbol = "x";
            symColor = "#FF0000";
          } else if (
            eventsArray[i].eventDescription.toLowerCase().indexOf("start") !==
            -1
          ) {
            if (
              eventsArray[i].eventDescription
                .toLowerCase()
                .indexOf("initiated") !== -1
            ) {
              symbol = "triangle-right-open";
            } else {
              symbol = "triangle-right";
            }

            if (
              eventsArray[i].eventDescription
                .toLowerCase()
                .indexOf("warnings") !== -1
            ) {
              symColor = "#FFC000";
            } else if (
              eventsArray[i].eventDescription
                .toLowerCase()
                .indexOf("failed") !== -1 ||
              eventsArray[i].eventDescription
                .toLowerCase()
                .indexOf("aborted") !== -1
            ) {
              symColor = "#FF0000";
            } else {
              symColor = "#92D050";
            }
          } else {
            // default is grean start symbol
            symbol = "x-dot";
            symColor = "#92D050";
          }
          objectToAdd.push({
            x: this.normalizeTimeStamp(eventsArray[i].siteTime),
            // x: Date.parse(eventsArray[i].siteTime),
            color: symColor,
            symbol: symbol,
            description: eventsArray[i].eventDescription,
          });
        }
      }
    }
    return objectToAdd;
  }

  normalizeTimeStamp(time) {
    const diff = moment.parseZone(time).utcOffset();
    return Date.parse(moment(time).add(diff, "minutes").toString());
  }

  fetchConfig(trainId: number) {
    const blackList = this.templateService.currentTemplate.tags;
    let i = 0;

    blackList.forEach((blackListSignal) => {
      if (blackListSignal.includes("*")) {
        blackList[i] = blackListSignal
          .substring(0, blackListSignal.length - 1)
          .toUpperCase();
      }
      i++;
    });

    return new Observable<TrendExplorerConfig>((subscriber) => {
      // Get starms tags
      this.starms
        .get(["signals/signaltags/trains", trainId])
        .pipe(
          map(
            (response: any[]) =>
              response.map((entry) => new Signaltag().deserialize(entry))
            // .filter(t => {
            //   const index = blackList.findIndex(bt => {
            //     return t.tagAlias.includes(bt)
            //   });
            //   if (index > -1) {
            //     return false;
            //   }
            //   return true;
            // })
          )
        )
        .subscribe(
          (tags: Signaltag[]) => {
            forkJoin(
              this.lds.getDataSources(),
              this.starms.get(["equipment", "trains", trainId]).pipe(
                map((rawEq: any[]) => {
                  return rawEq
                    .map((entry) => new Equipment().deserialize(entry))
                    .map((entry) => "Data." + entry.getLdsUniqueId());
                })
              )
            ).subscribe(
              ([ldsSources, equipment]) => {
                if (ldsSources.length && equipment.length) {
                  const trainLDSDataSources = equipment.filter(
                    (entry) => ldsSources.indexOf(entry) !== -1
                  );
                  if (trainLDSDataSources.length) {
                    const ldsTrainSource = trainLDSDataSources[0];
                    forkJoin(
                      this.lds.getTagsList(ldsTrainSource),
                      this.lds.getTimeZone(ldsTrainSource, 1)
                    ).subscribe(
                      ([ldsTags, timeZone]) => {
                        for (const tag of tags) {
                          tag.timeZone = timeZone.zoneId;

                          const ldsTagIndex = ldsTags.entries.findIndex(
                            (entry) => entry.tag === tag.tagName
                          );
                          if (ldsTagIndex > -1) {
                            tag.ldsMeta = ldsTags.entries[ldsTagIndex];
                          }
                        }
                        subscriber.next({
                          tags: tags,
                          timezone: timeZone.zoneId,
                          dataSource: ldsTrainSource,
                        });
                        subscriber.complete();
                      },
                      (error) => {
                        subscriber.next({
                          tags: tags,
                          timezone: null,
                          dataSource: null,
                        });
                        subscriber.complete();
                      }
                    );
                  } else {
                    subscriber.next({
                      tags: tags,
                      timezone: null,
                      dataSource: null,
                    });
                    subscriber.complete();
                  }
                } else {
                  subscriber.next({
                    tags: tags,
                    timezone: null,
                    dataSource: null,
                  });
                  subscriber.complete();
                }
              },
              (error) => {
                console.log(error);
                subscriber.next({
                  tags: tags,
                  timezone: null,
                  dataSource: null,
                });
                subscriber.complete();
              }
            );
          },
          (error) => {
            subscriber.error(error);
            subscriber.complete();
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/trend-explorer/trend-explorer.service.ts